import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import InvestorProfile from '../InvestorProfile';
import InvestorHasInvalidState from '../InvestorHasInvalidState';
import InvestorNotFound from '../InvestorNotFound';
import uploadAddressProofErrorHandler from '../uploadAddressProofErrorHandler';
import InvestorDoesNotHavePendingCorrections from '../InvestorDoesNotHavePendingCorrections';
import InvalidInvestorId from '../InvalidInvestorId';
import AddressError from './AddressError';
class AddressAPI extends HundredBricksAPI {
    async updateAddress(payload) {
        const { proofFile, addressProofType, typeOfRoad, street, externalNumber, internalNumber, zipCode, neighborhood, municipality, city, state, country } = payload;
        try {
            const formData = new FormData();
            formData.append('proofFile', proofFile);
            formData.append('proofType', addressProofType);
            formData.append('typeOfRoad', typeOfRoad);
            formData.append('street', street);
            formData.append('externalNumber', externalNumber);
            formData.append('internalNumber', (internalNumber ?? ''));
            formData.append('zipCode', zipCode);
            formData.append('neighborhood', neighborhood);
            formData.append('municipality', municipality);
            formData.append('city', city);
            formData.append('state', state);
            formData.append('country', country);
            const { data } = await this.client.put('v2/profile/address', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        uploadAddressProofErrorHandler(error);
                }
            }
            if (error instanceof Error) {
                throw new AddressError('Unexpected error on updating address', { cause: error });
            }
            throw new AddressError(`Unexpected error on updating address: '${error}'`);
        }
    }
    async correctAddress(payload) {
        const { typeOfRoad, street, externalNumber, internalNumber, zipCode, neighborhood, municipality, city, state, country } = payload;
        try {
            const formData = new FormData();
            formData.append('typeOfRoad', typeOfRoad);
            formData.append('street', street);
            formData.append('externalNumber', externalNumber);
            formData.append('internalNumber', (internalNumber ?? ''));
            formData.append('zipCode', zipCode);
            formData.append('neighborhood', neighborhood);
            formData.append('municipality', municipality);
            formData.append('city', city);
            formData.append('state', state);
            formData.append('country', country);
            const { data } = await this.client.post('v2/profile/address/correct', formData);
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_INVESTOR_ID':
                        throw new InvalidInvestorId({ cause: error });
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_DOES_NOT_HAVE_PENDING_CORRECTIONS':
                        throw new InvestorDoesNotHavePendingCorrections({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        throw new AddressError({ cause: error });
                }
            }
            if (error instanceof Error) {
                throw new AddressError('Unexpected error on correcting address', { cause: error });
            }
            throw new AddressError(`Unexpected error on correcting address: '${error}'`);
        }
    }
}
export default AddressAPI;
